import React, { useState, useCallback, useEffect } from 'react';
import {
  IonCardHeader,
  IonRow,
  IonCol,
  IonCardContent,
  IonLabel,
  IonInput,
  IonCard,
  IonLoading,
  IonTitle,
  IonSpinner,
  IonToast,
  IonButton,
  IonIcon,
} from '@ionic/react';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import './MyProfile.scss';
import Backdrop from '@material-ui/core/Backdrop';
import Modal from '../Modal/Modal';
import ChangePwdForm from '../ChangePassword/ChangePassword';
import MfaForm from '../MfaForm/MfaForm';
import TabPanel from '../TabPanel/TabPanel';
import { CloseOutlined } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';
import { Drawer, InputAdornment, TextField } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import { ReactComponent as ProfileImg } from '../../assets/images/icons/user.svg';
import { ReactComponent as SecurityImg } from '../../assets/images/icons/security.svg';
import SVLS_API from '../../svls-api';
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import { demoUserPrefix } from '../../util/stringUtil';
import { share, shareSocial } from 'ionicons/icons';
import { BRAND_DOMAIN, BRAND_NAME } from '../../constants/Branding';
import { connect } from 'react-redux';
import { BonusDetails } from '../../models/UserBet';
import { RootState } from '../../models/RootState';
import {
  Table,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Paper,
} from '@material-ui/core';
import moment from 'moment';
import BonusRewards from '../BonusRewards/BonusRewards';
type ToastProps = {
  message: string;
  color: string;
  show: boolean;
};

type UpdateUserPersonalDetailsrequest = {
  fullName: string;
  phoneNumber: string;
  emailId: string;
  address: string;
  city: string;
  pinCode: string;
};

type UserPersonalDetails = UpdateUserPersonalDetailsrequest & {
  username: string;
};
type BonusAccount = {
  turnover: number;
  referred_by: string;
  referral_count: number;
  completed_referrals: number;
};

type StateProps = {
  domainConfig: any;
  langData:any;
};

type RouteParams = {
  tab: string;
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MyProfile: React.FC<StateProps> = (props) => {
  const { domainConfig,langData } = props;
  //tab value for url
  const tabValueUrl = useQuery().get('tv');
  const { tab } = useParams<RouteParams>();
  const [loading, setLoading] = useState<boolean>(false);
  const [progress, setProgress] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<UserPersonalDetails>();
  const [referralCode, setReferralCode] = useState<UserPersonalDetails>();
  const [bonusAccount, setBonusAccount] = useState<BonusAccount>();
  const [bonusEarned, setBonusEarned] = useState<number>(0);
  const [bonusDetails, setBonusDetails] = useState<BonusDetails[]>([]);
  const [toastDetails, setToastDetails] = useState<ToastProps>({
    message: '',
    color: '',
    show: false,
  });
  const [changePwdMOdal, setChangePwdMOdal] = useState<boolean>(false);
  const [phoneUpdate, setPhoneUpdate] = useState<boolean>(false);
  const [open2FAModal, setOpen2FAModal] = useState<boolean>(false);
  const pageTabValData = {
  referral: 3,
  deposit: 2,
  bonus: 4,
};
  const [tabValue, setTabValue] = useState<number>(pageTabValData[tab] || 0);
  const [mfaEnabled, setMfaEnabled] = useState<boolean>(false);
  const history = useHistory();
  const [err, setErr] = useState<string>();

  const [phone, setPhone] = useState<any>('');
  const [otpTimer, setOtpTimer] = useState<number>();
  const [otpEnterFields, setOtpEnterFields] = useState<boolean>(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState<string>('');
  const [phoneNumbeErrorMsg, setPhoneNumbeErrorMsg] = useState<string>('');
  const [verificationErrorMsg, setVerificationErrorMsg] = useState<string>('');
  const [phoneNumberExists, setPhoneNumberExists] = useState<boolean>(false);
  const [country, setCountry] = useState<any>('');
  const [phoneFormat, setPhoneFormat] = useState<any>('');

  const [otp, setOtp] = useState<number>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const userName = sessionStorage.getItem('username');
      const response = await SVLS_API.get(
        `/account/v2/users/${userName}/profile`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      setUserDetails(response.data);
      // setPhone(response.data.phone);
    } catch (err) {
      setErr(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchReferralCode = async () => {
    setLoading(true);
    try {
      const userName = sessionStorage.getItem('aid');
      const response = await SVLS_API.get(
        `/account/v2/accounts/${userName}/referral-code`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      setReferralCode(response.data);
      // setPhone(response.data.phone);
    } catch (err) {
      setErr(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchBonusDetails = async () => {
    setLoading(true);
    try {
      const response = await SVLS_API.get(
        '/marketing/v1/bonuses/user/referral-details',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200) {
        setBonusDetails(response?.data?.referred_users);
        setBonusEarned(response?.data?.total_bonus_earned);
      }
    } catch (err) {
      setErr(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchBonusAccount = async () => {
    setLoading(true);
    try {
      const userName = sessionStorage.getItem('aid');
      const response = await SVLS_API.get(
        `marketing/v1/bonus-accounts/accounts/${userName}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      setBonusAccount(response.data);
      // setPhone(response.data.phone);
    } catch (err) {
      setErr(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchReferralCode();
    fetchBonusAccount();
    fetchBonusDetails();
  }, []);

  useEffect(() => {
    if (userDetails?.phoneNumber) {
      setPhone(userDetails.phoneNumber);
    }
  }, [userDetails?.phoneNumber]);

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const pinCodeRegex = /^[1-9][0-9]{5}$/;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fullName: userDetails ? userDetails.fullName : '',
      phoneNumber: userDetails ? userDetails.phoneNumber : '',
      emailId: userDetails ? userDetails.emailId : '',
      address: userDetails ? userDetails.address : '',
      city: userDetails ? userDetails.city : '',
      pinCode: userDetails ? userDetails.pinCode : '',
    },
    validationSchema: Yup.object({
      phoneNumber: Yup.string().matches(
        phoneRegExp,
        'Phone number is not valid'
      ),
      pinCode: Yup.string().matches(pinCodeRegex, 'Pin Code is not valid'),
    }),
    onSubmit: (values) => {
      let data: UpdateUserPersonalDetailsrequest = {
        fullName: values.fullName,
        phoneNumber: values.phoneNumber,
        emailId: values.emailId,
        address: values.address,
        city: values.city,
        pinCode: values.pinCode,
      };
      updateDetails(data);
    },
  });

  const updateDetails = async (data: UpdateUserPersonalDetailsrequest) => {
    try {
      setErr('');
      setProgress(true);
      const userName = sessionStorage.getItem('username');
      const response = await SVLS_API.put(
        `/account/v2/users/${userName}/profile`,
        data,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        setToastDetails({
          message: langData?.['details_saved_success_txt'],
          color: 'success',
          show: true,
        });
      } else {
        setToastDetails({
          message: langData?.['details_save_failed_txt'],
          color: 'danger',
          show: true,
        });
      }
      fetchData();
    } catch (err) {
      setErr(err?.response?.data?.message);
      setToastDetails({
        message:langData?.['details_save_failed_txt'],
        color: 'danger',
        show: true,
      });
    } finally {
      setProgress(false);
    }
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };

  const checkPhoneNumberExists = async (phoneNumber: string) => {
    if (phoneNumber === userDetails?.phoneNumber) {
      return;
    }
    try {
      const response: any = await SVLS_API.get(
        `/account/v2/users/phones/${phoneNumber}/:exists`
      );
      if (response.status === 200) {
        if (response.data === true) {
          setPhoneNumbeErrorMsg(langData?.['phone_number_exists_txt']);
          setPhoneNumberExists(true);
        } else {
          setPhoneNumbeErrorMsg('');
          setPhoneNumberExists(false);
        }
      }
    } catch (err) {
      setPhoneNumbeErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const generateOtp = async () => {
    setPhoneNumbeErrorMsg('');
    const claims = sessionStorage.getItem('jwt_token').split('.')[1];
    const username = JSON.parse(window.atob(claims)).sub;
    try {
      const response: any = await SVLS_API.post(
        `/account/v2/otp/?mobileNumber=${phone}&username=${username}&otpType=UPDATE_PHONE_NUMBER`
      );
      if (response.status === 204) {
        handleOtpTimer(60);
        setPhoneUpdate(false);
        setOtpEnterFields(true);
      }
    } catch (err) {
      setPhoneNumbeErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNextStep = () => {
    if (phone === '') {
      toast.error(langData?.['enter_phone_number_required_txt'])
      return;
    }
    if (!otp || otp.toString().length !== 6) {
      setOtpErrorMessage(langData?.['enter_valid_otp_txt']);
      return;
    }
    setOtpErrorMessage('');
    setLoading(true);
    validateOtp();
  };

  const validateOtp = async () => {
    setVerificationErrorMsg('');
    try {
      if (country.format.length === phoneFormat.length) {
        const response: any = await SVLS_API.post(
          `/account/v2/otp/validate?mobileNumber=${phone}&otp=${otp}`,
          {}
        );
        if (response.status === 204 || response.status === 200) {
          setOtpErrorMessage('');
          updatePhoneNumber();
        }
      }
    } catch (err) {
      setVerificationErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const updatePhoneNumber = async () => {
    setVerificationErrorMsg('');
    try {
      const claims = sessionStorage.getItem('jwt_token').split('.')[1];
      const username = JSON.parse(window.atob(claims)).sub;
      if (country.format.length === phoneFormat.length) {
        const response: any = await SVLS_API.put(
          `/account/v2/users/${username}/phoneNumber`,
          {
            phone_number: phone,
            otp: otp,
          },
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
          }
        );
        if (response.status === 204 || response.status === 200) {
          setOtpErrorMessage('');
          toast.success(
            <div>
              <SuccessIcon /> {langData?.['phone_no_update_success_txt']}
            </div>,
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          setPhoneNumberExists(false);
          setOtpEnterFields(false);
          setPhoneUpdate(false);
        }
      }
    } catch (err) {
      setVerificationErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneUpdate = (flag: boolean) => {
    if (flag && !phoneUpdate && otpEnterFields) {
      setOtpEnterFields(false);
    }
    if (!flag) {
      setPhone(userDetails?.phoneNumber);
    }
    setPhoneUpdate(flag);
  };

  useEffect(() => {
    if (
      country &&
      country?.dialCode &&
      phone &&
      phone?.length - country?.dialCode?.length + 1 > 10
    ) {
      checkPhoneNumberExists(phone);
    }
  }, [phone]);

  const copyText = () => {
    let text = `${referralCode}`;
    navigator.clipboard.writeText(text);
    toast.success(langData?.['referral_link_copied_txt']);
  };

  const generateRefLink = () => {
    let link = `${BRAND_DOMAIN}/register?refCode=${referralCode}`;
    navigator.clipboard.writeText(link);
    toast.success(langData?.['referral_link_copied_txt']);
  };

  return (
    <>
      <IonRow>
        <IonCol sizeLg="2" sizeMd="2.2" className="profile-sidebar web-view">
          <div className="profile-menu">
            <IonCard className="profile-menu-card web-view">
              <IonCardContent className="profile-menu-card-content">
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="EventsTypes Menu"
                  className="eventTypes-menu-tabs"
                  scrollButtons="off"
                >
                  <div
                    className={
                      tabValue == 0
                        ? 'active profile-sidebar-tabs'
                        : 'profile-sidebar-tabs'
                    }
                    onClick={(e) => handleTabChange(e, 0)}
                  >
                    <ProfileImg className="my-profile-icon sidebar-btn-icons" />{' '}
                    {langData?.['my_profile']}
                  </div>
                  {sessionStorage
                    .getItem('username')
                    ?.startsWith(demoUserPrefix) ? null : (
                    <div
                      className={
                        tabValue == 1
                          ? 'active profile-sidebar-tabs'
                          : 'profile-sidebar-tabs'
                      }
                      onClick={(e) => handleTabChange(e, 1)}
                    >
                      <SecurityImg className="sidebar-btn-icons " />
                      {langData?.['security']}{' '}
                    </div>
                  )}
                  <div
                    className={
                      tabValue == 2
                        ? 'active profile-sidebar-tabs'
                        : 'profile-sidebar-tabs'
                    }
                    onClick={(e) => handleTabChange(e, 2)}
                  >
                    <ProfileImg className="my-profile-icon sidebar-btn-icons" />{' '}
                    {langData?.['contact']}{' '}
                  </div>
                  {domainConfig.bonus ? (
                    <div
                      className={
                        tabValue == 3
                          ? 'active profile-sidebar-tabs'
                          : 'profile-sidebar-tabs'
                      }
                      onClick={(e) => handleTabChange(e, 3)}
                    >
                      <ProfileImg className="my-profile-icon sidebar-btn-icons" />{' '}
                      {langData?.['referrals']}{' '}
                    </div>
                  ) : null}
                  <div
                    className={
                      tabValue == 4
                        ? 'active profile-sidebar-tabs'
                        : 'profile-sidebar-tabs'
                    }
                    onClick={(e) => handleTabChange(e, 4)}
                  >
                    <ProfileImg className="my-profile-icon sidebar-btn-icons" />{' '}
                    {langData?.['header_bonus_txt']}{' '}
                  </div>

                  {/* <NavLink
              className="eventTypes-menu-nav-link"
              to="/exchange_sports/binary"
            >
              <Tab
                className="eventTypes-menu-tab"
                label="Binary"
                value={11010011}
              />
            </NavLink> */}
                </Tabs>
              </IonCardContent>
            </IonCard>
          </div>
        </IonCol>
        <IonCol>
          <IonToast
            isOpen={toastDetails.show}
            onDidDismiss={() =>
              setToastDetails({
                message: '',
                color: '',
                show: false,
              })
            }
            message={toastDetails.message}
            color={toastDetails.color}
            position="top"
            duration={1000}
          />
          <div className="my-profile-ctn">
            <div className="profile-title mob-view">
              <ProfileImg className="my-profile-icon" />
              {langData?.['my_profile']}
            </div>
            {/* <IonCardHeader className="my-profile-ctn-header">
          <IonTitle className="page-title">My Profile</IonTitle>
        </IonCardHeader> */}
            {/* <IonCardContent className="my-profile-user-details-ctn"> */}
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className="mob-view my-profile-tabs"
            >
              <Tab value={0} label={langData?.['my_profile']} className="my-profile-tab" />
              {sessionStorage
                .getItem('username')
                ?.startsWith(demoUserPrefix) ? null : (
                <Tab value={1} label={langData?.['security']} className="my-profile-tab" />
              )}
              <Tab value={2} label={langData?.['contact']} className="my-profile-tab" />
              {domainConfig.bonus ? (
                <Tab value={3} label={langData?.['referral']} className="my-profile-tab" />
              ) : null}
              <Tab value={4} label={langData?.['bonus']} className="my-profile-tab" />
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <div className="personal-tab-ctn">
                {loading ? (
                  <IonLoading
                    isOpen={loading}
                    message={langData?.['fetching_user_details']}
                  />
                ) : (
                  <form onSubmit={formik.handleSubmit}>
                    <IonRow className=" mob-input-ctn">
                      <IonCol
                        className="label-col"
                        sizeLg="1.2"
                        sizeMd="3"
                        sizeSm="3"
                        sizeXs="3"
                      >
                        <IonLabel className=" label-col">{langData?.['username']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonLabel className="username">
                          <IonInput
                            className="profile-input username-input"
                            id="user-adornment-FullName"
                            type="text"
                            name="fullName"
                            disabled
                          >
                            {userDetails
                              ? userDetails.username?.startsWith(demoUserPrefix)
                                ? 'Demo User'
                                : userDetails.username
                              : null}
                          </IonInput>
                        </IonLabel>
                      </IonCol>
                    </IonRow>
                    {/* <div className="content-header">Personal Information</div> */}
                    <IonRow className="mob-input-ctn">
                      <IonCol
                        className="label-col"
                        sizeLg="1.2"
                        sizeMd="3"
                        sizeSm="3"
                        sizeXs="3"
                      >
                        <IonLabel className="label-col">{langData?.['full_name']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonInput
                          className="profile-input"
                          id="user-adornment-FullName"
                          type="text"
                          name="fullName"
                          value={formik.values.fullName}
                          onInput={(e) => formik.handleChange(e)}
                        />
                        {formik.touched.fullName && formik.errors.fullName ? (
                          <FormHelperText
                            id="my-helper-text"
                            className="my-helper-text"
                          >
                            {formik.errors.fullName}
                          </FormHelperText>
                        ) : null}
                      </IonCol>
                    </IonRow>
                    <IonRow className="mob-input-ctn">
                      <IonCol
                        className="label-col"
                        sizeLg="1.2"
                        sizeMd="3"
                        sizeSm="3"
                        sizeXs="3"
                      >
                        <IonLabel className="label-col">{langData?.['email']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonInput
                          className="profile-input"
                          id="user-adornment-emailId"
                          type="email"
                          name="emailId"
                          value={formik.values.emailId}
                          onInput={(e) => formik.handleChange(e)}
                          required
                        />
                        {formik.touched.emailId && formik.errors.emailId ? (
                          <FormHelperText
                            id="my-helper-text"
                            className="my-helper-text"
                          >
                            {formik.errors.emailId}
                          </FormHelperText>
                        ) : null}
                      </IonCol>
                    </IonRow>

                    <IonRow className="mob-input-ctn">
                      <IonCol
                        className="label-col"
                        sizeLg="1.2"
                        sizeMd="3"
                        sizeSm="3"
                        sizeXs="3"
                      >
                        <IonLabel className="label-col">{langData?.['address']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonInput
                          className="profile-input"
                          name="address"
                          value={formik.values.address}
                          onInput={(e) => formik.handleChange(e)}
                        ></IonInput>
                        {formik.touched.address && formik.errors.address ? (
                          <FormHelperText
                            id="my-helper-text"
                            className="my-helper-text"
                          >
                            {formik.errors.address}
                          </FormHelperText>
                        ) : null}
                      </IonCol>
                    </IonRow>
                    <IonRow className="mob-input-ctn">
                      <IonCol className="label-col" sizeLg="1.2">
                        <IonLabel className="label-col">{langData?.['city']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonInput
                          className="profile-input"
                          name="city"
                          value={formik.values.city}
                          onInput={(e) => formik.handleChange(e)}
                        ></IonInput>
                        {formik.touched.city && formik.errors.city ? (
                          <FormHelperText
                            id="my-helper-text"
                            className="my-helper-text"
                          >
                            {formik.errors.city}
                          </FormHelperText>
                        ) : null}
                      </IonCol>
                    </IonRow>
                    <IonRow className="mob-input-ctn">
                      <IonCol className="label-col" sizeLg="1.2">
                        <IonLabel className="label-col">{langData?.['pincode']}</IonLabel>
                      </IonCol>
                      <IonCol sizeLg="5" sizeMd="9" sizeSm="9" sizeXs="9">
                        <IonInput
                          className="input-address profile-input"
                          name="pinCode"
                          value={formik.values.pinCode}
                          onInput={(e) => formik.handleChange(e)}
                        ></IonInput>
                        {formik.touched.pinCode && formik.errors.pinCode ? (
                          <FormHelperText
                            id="my-helper-text"
                            className="my-helper-text"
                          >
                            {formik.errors.pinCode}
                          </FormHelperText>
                        ) : null}
                      </IonCol>
                    </IonRow>
                    <IonRow className="my-profile-ctn-footer">
                      <Button
                        className="submit-btn"
                        color="primary"
                        type="submit"
                        endIcon={
                          progress ? <IonSpinner name="lines-small" /> : null
                        }
                        variant="contained"
                      >
                        {langData?.['save']}
                      </Button>
                    </IonRow>
                  </form>
                )}
              </div>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <div className="security-tab-ctn">
                <IonRow className="security-row">
                  <IonLabel className="label-col">{langData?.['password']}</IonLabel>
                  <IonButton
                    className="change-pwd-btn web-view"
                    fill="solid"
                    onClick={() => setChangePwdMOdal(true)}
                  >
                    <span className="btn-text">{langData?.['change']}</span>
                  </IonButton>
                  <IonButton
                    className="change-pwd-btn mob-view"
                    fill="solid"
                    onClick={() => history.push('/change-password')}
                  >
                    <span className="btn-text">{langData?.['change']}</span>
                  </IonButton>
                </IonRow>
              </div>
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <div className="contacts-tab-ctn">
                <IonRow className="input-row">
                  <div className="input-label">{langData?.['phone_number']}</div>
                  <div className="contact-and-update">
                    <PhoneInput
                      country={'in'}
                      placeholder={langData?.['enter_phone_number_txt']}
                      value={phone}
                      onChange={(value, country, e, formattedValue) => {
                        setPhone(value);
                        setCountry(country);
                        setPhoneFormat(formattedValue);
                      }}
                      disabled={otpEnterFields || !phoneUpdate}
                    />

                    <IonButton
                      className="update-phone-btn"
                      fill="solid"
                      onClick={() => handlePhoneUpdate(!phoneUpdate)}
                    >
                      <span className="btn-text">
                        {phoneUpdate ? langData?.['cancel'] : langData?.['update']}
                      </span>
                    </IonButton>
                  </div>
                  {phoneNumbeErrorMsg ? (
                    <FormHelperText error id="my-helper-text">
                      {phoneNumbeErrorMsg}
                    </FormHelperText>
                  ) : null}
                </IonRow>

                <div className="btn-section">
                  {!otpEnterFields &&
                  phoneUpdate &&
                  phone !== '' &&
                  phone !== userDetails?.phoneNumber &&
                  phone?.length - country?.dialCode.length + 1 > 10 &&
                  !phoneNumberExists ? (
                    <Button
                      className="btn"
                      color="primary"
                      type="submit"
                      variant="contained"
                      endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                      disabled={
                        phone === '' ||
                        (phone && phone?.length < 10) ||
                        otpEnterFields
                      }
                      onClick={() => generateOtp()}
                    >
                      {langData?.['send_otp']}
                    </Button>
                  ) : null}
                </div>
                {otpEnterFields ? (
                  <>
                    <IonRow className="input-row">
                      {/* <IonCol sizeLg="4" sizeMd="6" sizeXs="12" className="input-col"> */}
                      {/* <div className="input-row flex-column"> */}
                      <div className="input-label">{langData?.['otp']} *</div>
                      <NumberFormat
                        className="input-box"
                        name="otp"
                        variant="outlined"
                        placeholder="Enter OTP"
                        decimalSeparator={false}
                        onChange={(e) => setOtp(Number(e.target.value))}
                      />
                      {verificationErrorMsg ? (
                        <FormHelperText error id="my-helper-text">
                          {verificationErrorMsg}
                        </FormHelperText>
                      ) : null}

                      {otpErrorMessage ? (
                        <FormHelperText error id="my-helper-text">
                          {otpErrorMessage}
                        </FormHelperText>
                      ) : null}

                      <div
                        className="label link"
                        onClick={() => {
                          if (!otpTimer) {
                            generateOtp();
                          }
                        }}
                      >
                        {otpTimer !== undefined &&
                        otpTimer !== null &&
                        otpTimer >= 0
                          ? `Resend in ${otpTimer} sec`
                          : 'Resend OTP'}
                      </div>
                      {/* </div> */}
                      {/* </IonCol> */}
                    </IonRow>
                    <div className="btn-section">
                      <Button
                        className="btn"
                        color="primary"
                        type="submit"
                        variant="contained"
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                        onClick={() => handleNextStep()}
                      >
                        {langData?.['verify_otp']}
                      </Button>
                    </div>
                  </>
                ) : null}
              </div>
            </TabPanel>
            {domainConfig.bonus ? (
              <TabPanel value={tabValue} index={3}>
                <div className="contacts-tab-ctn">
                  <div className="referral-card-bg">
                    <div className="referral-heading">
                      {langData?.['earn_bonus_txt']}
                    </div>
                    <div className="referral-content">
                      {`${langData?.['refer_someone_to']} ${BRAND_NAME} ${langData?.['bonus_condition_platform']}`}
                    </div>
                  </div>

                  <div className="summary-cards-row">
                    <div className="summary-cards">
                      <div className="summary-cards-header">
                        {langData?.['total_bonus_earned']}
                      </div>
                      <div className="summary-cards-content">{bonusEarned}</div>
                    </div>

                    <div className="summary-cards">
                      <div className="summary-cards-header">
                        {langData?.['completed_referrals']}
                      </div>
                      <div className="summary-cards-content">
                        {' '}
                        {bonusAccount?.completed_referrals ?? '0'}{' '}
                      </div>
                    </div>
                    <div className="summary-cards">
                      <div className="summary-cards-header">
                        {' '}
                        {langData?.['accepted_referrals']}
                      </div>
                      <div className="summary-cards-content">
                        {bonusAccount?.referral_count ?? '0'}
                      </div>
                    </div>
                  </div>

                  {referralCode && (
                    <IonRow className="input-row referral-sub-section">
                      <div className="input-label sub-header">
                        {langData?.['your_unique_referral_link']}:
                      </div>
                      <div className="update-row">
                        <span
                          title="Click to Code"
                          className="referral-code-field"
                          onClick={() => copyText()}
                        >
                          {referralCode}
                        </span>
                        <Button
                          className="referral-code-copy-btn"
                          onClick={() => generateRefLink()}
                        >
                          {langData?.['copy_link']}
                        </Button>
                      </div>
                    </IonRow>
                  )}
                  <div className="referral-table">
                    <div className="referral-label ">{langData?.['track_your_referral']}:</div>
                    <TableContainer component={Paper}>
                      <Table className="bets-tbl" aria-label="simple table">
                        <TableHead className="referral-history-header">
                          <TableRow className="referral-history-row">
                            <TableCell
                              className="referral-history-cell"
                              align="center"
                            >
                              {langData?.['date']}
                            </TableCell>
                            <TableCell
                              className="referral-history-cell"
                              align="center"
                            >
                              {langData?.['friend_user_name']}
                            </TableCell>
                            <TableCell
                              className="referral-history-cell"
                              align="center"
                            >
                              {langData?.['reward_earned']}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        {bonusDetails.length > 0 ? (
                          <>
                            <TableBody>
                              {bonusDetails?.map((row) => (
                                <TableRow>
                                  <TableCell align="center">
                                    {moment(row.referred_date).format(
                                      'DD-MM-YY, h:mm:ss A'
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    {' '}
                                    {row?.username}
                                  </TableCell>
                                  <TableCell align="center">
                                    {' '}
                                    {row?.reward_earned}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </>
                        ) : (
                          <TableCell
                            className="no-data-row bordernone"
                            colSpan={9}
                          >
                            <div className="no-bets-msg">{langData?.['no_details_found']}</div>
                          </TableCell>
                        )}
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </TabPanel>
            ) : null}
            <TabPanel value={tabValue} index={4}>
              <div className="security-tab-ctn">
                <BonusRewards />
              </div>
            </TabPanel>
          </div>
        </IonCol>
      </IonRow>

      <Backdrop className="backdrop-ctn" open={open2FAModal}>
        <Modal
          open={open2FAModal}
          closeHandler={() => setOpen2FAModal(false)}
          title="Set up MFA"
          size="sm"
        >
          <MfaForm
            closeMfaFormModal={() => setOpen2FAModal(false)}
            mfaStatusChangeHandler={(status) => setMfaEnabled(status)}
          ></MfaForm>
        </Modal>
      </Backdrop>
      <Backdrop className="backdrop-ctn" open={changePwdMOdal}>
        <Drawer
          anchor={'right'}
          open={changePwdMOdal}
          onClose={() => setChangePwdMOdal(true)}
          className="light-bg-title game-rules-drawer"
          title="Change Password"
          // size="md"
        >
          <div className="game-rules-header">
            <div className="game-rules-title">{langData?.['change_password_txt']}</div>
            <div
              className="game-rules-close cursor"
              onClick={() => setChangePwdMOdal(false)}
            >
              <CloseOutlined />
            </div>
          </div>
          <ChangePwdForm
            closeHandler={() => setChangePwdMOdal(false)}
            backHandler={() => {}}
          />
        </Drawer>
        {/* <Modal
          open={changePwdMOdal}
          closeHandler={() => setChangePwdMOdal(false)}
          title="Change Password"
          size="xs"
        >
          <ChangePwdForm
            closeHandler={() => setChangePwdMOdal(false)}
            backHandler={() => { }}
          />
        </Modal> */}
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    domainConfig: state.common.domainConfig,
    langData:state.common.langData
  };
};

export default connect(mapStateToProps)(MyProfile);
